import { createAxiosInstance } from '@servicetitan/cp-api';
import { inject, injectable, optional } from '@servicetitan/react-ioc';
import { SchedulerSettingsClient, SettingsClient } from './settings-client';

@injectable()
export class SettingsApi {
    client: SettingsClient;
    schedulerSettingsClient: SchedulerSettingsClient;

    constructor(@inject('baseUrl') @optional() baseUrl?: string) {
        this.client = new SettingsClient(baseUrl, createAxiosInstance());
        this.schedulerSettingsClient = new SchedulerSettingsClient(baseUrl, createAxiosInstance());
    }
    getSpecialSettings(key: string): Promise<any> {
        return this.client.getSpecialSettings(key).catch((_error: any) => {
            if (_error.status === 404) {
                return null;
            }

            throw _error;
        });
    }
}
